<div class="image-uploader">
  <div class="caption">{{ caption() }}</div>

  @if (showPreview() && currentImagePreview()) {
    <div>
      <div class="image-preview">
        <img [src]="currentImagePreview()" alt="Image preview" class="preview-image" />
      </div>
    </div>
  }

  @if (!disabled) {
    <div>      
      @if (currentImagePreview() && showRemoveButton()) {
        <app-link iconClass="dx-icon-trash" (onClick)="removeImage()">Remove Image</app-link>
      }
    </div>
  }

  @if (!disabled) {
    <div>
      <div>
        <app-single-file-upload 
          [allowedFileExtensions]="allowedTypes()"
          [maxFileSize]="maxSizeBytes()" 
          (fileSelected)="onFileSelected($event)"
          caption="Select image file">
        </app-single-file-upload>

        @if (showValidationText()) {
          <small class="form-text text-muted">
            {{ getAllowedTypesText() }}
          </small>
        }
      </div>
    </div>
  }
</div>